import { useDrag } from "react-dnd";
import { ItemTypes } from "../../utils/constants";
import { CHEMISTRY_ICONS } from "../../data/chemistryIcons";

const EFFECT_EMOJIS = {
  bubbles: "🫧",
  fire: "🔥",
  smoke: "💨",
  crystal: "❄️",
  colorChange: "🎨",
};

export default function ReagentBottle({
  reagent,
  disabled,
  isExpected,
  category = "reagent",
}) {
  const dragType =
    category === "effect"
      ? ItemTypes.EFFECT
      : category === "tool"
      ? ItemTypes.TOOL
      : ItemTypes.REAGENT;

  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: dragType,
      item: {
        id: reagent.id,
        name: reagent.name,
        color: reagent.color,
        icon: reagent.icon,
        category,
      },
      canDrag: () => !disabled,
      collect: (monitor) => ({ isDragging: monitor.isDragging() }),
    }),
    [disabled, reagent.id, category]
  );

  // SVG → if missing → fallback to emoji
  const iconSrc = CHEMISTRY_ICONS[reagent.icon];

  const fallback = category === "effect" ? EFFECT_EMOJIS[reagent.id] : "⚗️";

  return (
    <div
      ref={drag}
      className={[
        "flex flex-col items-center justify-center p-3 rounded-xl shadow-md text-white transition-all duration-200 w-28",
        isDragging ? "opacity-40 scale-90" : "hover:scale-105",
        disabled ? "opacity-30 cursor-not-allowed" : "cursor-grab",
        isExpected && !disabled ? "ring-2 ring-offset-2 ring-blue-400" : "",
      ].join(" ")}
      style={{ backgroundColor: reagent.color }}
      title={disabled ? "Complete previous step first" : reagent.name}
    >
      {iconSrc ? (
        <img
          src={iconSrc}
          alt={reagent.name}
          className="w-8 h-8 mb-1 object-contain drop-shadow-sm"
        />
      ) : (
        <div className="text-3xl mb-1">{fallback}</div>
      )}

      <span className="text-xs font-medium text-center leading-tight">
        {reagent.name}
      </span>
    </div>
  );
}
